module.exports = __webpack_public_path__ + "img/zuja-1.4d937f85.jpg";